module.exports = __webpack_public_path__ + "static/media/chief-cover-Desktop.c030b181.png";